var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloselock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secured-lock 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4066 5.76344H10.7432V3.74354C10.7432 1.67955 9.06402 0 7.00014 0C4.93551 0 3.25664 1.67932 3.25664 3.74354V5.76344H2.59349C2.21182 5.76344 1.90259 6.07283 1.90259 6.45435V13.3091C1.90259 13.6907 2.21182 14 2.59349 14H11.4066C11.7875 14 12.0975 13.6907 12.0975 13.3091V6.45435C12.0975 6.07283 11.7874 5.76344 11.4066 5.76344ZM4.63829 3.74354C4.63829 2.441 5.69761 1.38169 7.0001 1.38169C8.3023 1.38169 9.36165 2.441 9.36165 3.74354V5.76344H4.63829V3.74354Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloselock);
export default __webpack_public_path__ + "static/media/closelock.7fca6b83e48e0c546b6091491b98137e.svg";
export { ForwardRef as ReactComponent };